// Actions
import {
  SET_FEMALE,
  SET_MALE,
  SET_OTHER_THIRD_GENDER,
  SET_GENDER_STATE
} from "../actionTypes/gender.actionTypes";

// Classes
import { GenderReducerState } from "../classes/gender.classes";

const initialState = new GenderReducerState();

export const GenderReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_FEMALE:
      return { ...state, female: action.payload };
    case SET_MALE:
      return { ...state, male: action.payload };
    case SET_OTHER_THIRD_GENDER:
      return { ...state, otherThirdGender: action.payload };
    case SET_GENDER_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
